import { forwardRef } from 'react';
import { capitalize } from 'lodash';
import { Avatar as MuiAvatar } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getCoverImage, getImageThumbUrl } from '@sda/utils/image';
import type { ImageInput } from '@sda/utils/image/interfaces';
import type { AvatarProps as MuiAvatarProps } from '@mui/material';

const useStyles = makeStyles({ name: 'Avatar' })((theme) => ({
  root: {
    textDecoration: 'none',
    height: theme.spacing(5),
    width: theme.spacing(5),
  },
  interactive: {
    cursor: 'pointer',

    '&:hover': {
      opacity: 0.6,
      transition: '0.5s',
    },
  },
  sizeMedium: {

  },
  sizeSmall: {
    height: 33,
    width: 33,
  },
}));

interface AvatarProps extends MuiAvatarProps {
  readonly fallback: string;
  readonly images: ImageInput;
  readonly onClick?: (...args: any[]) => any;
  readonly className?: string;
  readonly size?: 'small' | 'medium';
}

export const Avatar = forwardRef<HTMLImageElement, AvatarProps>(({
  fallback, images, onClick,
  className = '',
  size = 'medium',
  ...restProps
}, ref) => {
  const { classes, cx } = useStyles();

  const avatarClasses = cx(
    classes.root,
    onClick && classes.interactive,
    className,
    classes[`size${capitalize(size)}`],
  );

  let extraProps = {};

  if (onClick) {
    extraProps = {
      role: 'button',
      onClick,
    };
  }

  return (
    <MuiAvatar
      className={avatarClasses}
      ref={ref}
      src={getCoverImage(images, fallback, getImageThumbUrl)}
      {...extraProps}
      {...restProps}
    />
  );
});
